import(/* webpackMode: "eager" */ "/vercel/path0/src/app/admin-application-review/page.tsx");
